"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPromptUserForAssetsForEditor = getPromptUserForAssetsForEditor;
exports.promptUserForAssetsAsync = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var React = _interopRequireWildcard(require("react"));

var _ReactHelper = require("@civicplus/preamble/lib/Utilities/ReactHelper");

var _ProductThemeProvider = _interopRequireDefault(require("@civicplus/preamble/lib/ProductThemeProvider"));

var _AssetSelector = _interopRequireDefault(require("../AssetSelector/AssetSelector"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AssetSelectorModal = function AssetSelectorModal(_ref) {
  var onAssetsLinked = _ref.onAssetsLinked,
      close = _ref.close,
      options = _ref.options;

  var _useState = (0, React.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onClose = function onClose() {
    setOpen(false);

    if (close) {
      close();
    }
  };

  return /*#__PURE__*/React.createElement(_AssetSelector["default"], (0, _extends2["default"])({
    multiple: options.allowMultipleChoices
  }, options, {
    onAssetsLinked: onAssetsLinked,
    showFilter: true,
    ShowAsDialog: true,
    openDialog: open,
    onCloseDialog: onClose,
    onCancel: onClose
  }));
};

AssetSelectorModal.propTypes = {
  /**
   * Callback fired on linked
   */
  onAssetsLinked: _propTypes["default"].func,

  /**
   * Callback fired on close
   */
  close: _propTypes["default"].func,

  /**
   * Options
   */
  options: _propTypes["default"].object
};

var promptUserForAssetsAsync = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(options, productThemeProviderOptions) {
    var themeOptions, result, assets;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            themeOptions = _objectSpread({
              product: "preamble",
              specificity: 3
            }, productThemeProviderOptions);
            _context.next = 3;
            return (0, _ReactHelper.promiseViaComponent)(function (close, resolve) {
              return /*#__PURE__*/React.createElement(_ProductThemeProvider["default"], themeOptions, /*#__PURE__*/React.createElement(AssetSelectorModal, {
                close: close,
                onAssetsLinked: resolve,
                options: options
              }));
            }, {});

          case 3:
            result = _context.sent;
            assets = result.map(function (asset) {
              return _objectSpread(_objectSpread({}, asset), {}, {
                url: "".concat(options.config.baseUrl, "/api/assets/").concat(asset.id)
              });
            });
            return _context.abrupt("return", assets);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function promptUserForAssetsAsync(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.promptUserForAssetsAsync = promptUserForAssetsAsync;

function getPromptUserForAssetsForEditor(config) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(options) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options.config = config;
              _context2.next = 3;
              return promptUserForAssetsAsync(options);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}